import { useInspectionChecklistsQuery } from 'src/shared/graphql/generated';

type Params = {
  jobId: number;
};

export const useHasInspectionChecklists = ({ jobId }: Params) => {
  const { data, loading } = useInspectionChecklistsQuery({
    variables: {
      jobId: jobId as unknown as string,
    },
  });

  return {
    hasChecklists: !!data?.inspectionChecklists?.nodes?.length,
    loading,
  };
};
